import BronzePast from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/bronze.png';
import SilverPast from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/silver.png';
import GoldPast from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/gold.png';

import Bronze from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/bronze.png';
import Silver from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/silver.png';
import Gold from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/gold.png';
import Platinum from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/platinum.png';
import Emerald from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/emerald.png';
import Diamond from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/diamond.png';
import Epic from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/epic.png';
import Legend from '@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/legend.png';

import * as CertificateConstants from './certificate-constants';

import { useTranslations } from '../hooks/use-translations';

export const useCertificatesConfig = () => {
    const {
        bronze,
        silver,
        gold,
        platinum,
        emerald,
        diamond,
        epic,
        legend
    } = useTranslations();
    const {
        BRONZE,
        SILVER,
        GOLD,
        PLATINUM,
        EMERALD,
        DIAMOND,
        EPIC,
        LEGEND
    } = CertificateConstants;
    const newCertificatesConfig = [
        {
            ...BRONZE,
            icon: Bronze,
            title: bronze
        },
        {
            ...SILVER,
            icon: Silver,
            title: silver
        },
        {
            ...GOLD,
            icon: Gold,
            title: gold
        },
        {
            ...PLATINUM,
            icon: Platinum,
            title: platinum
        },
        {
            ...EMERALD,
            icon: Emerald,
            title: emerald
        },
        {
            ...DIAMOND,
            icon: Diamond,
            title: diamond
        },
        {
            ...EPIC,
            icon: Epic,
            title: epic
        },
        {
            ...LEGEND,
            icon: Legend,
            title: legend
        }
    ];

    const pastCertificatesConfig = [
        {
            ...BRONZE,
            icon: BronzePast,
            title: bronze
        },
        {
            ...SILVER,
            icon: SilverPast,
            title: silver
        },
        {
            ...GOLD,
            icon: GoldPast,
            title: gold
        }
    ];

    return {
        newCertificatesConfig,
        pastCertificatesConfig
    };
};



// WEBPACK FOOTER //
// ./containers/participation/config/certificates-config.js